function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(.8)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 31,
  x: 0.7,
  y: 0.5,
  fill: "url(#a)",
  fillRule: "nonzero",
  stroke: "#BEBFCB",
  rx: 2.03
}), /*#__PURE__*/React.createElement("path", {
  fill: "#498FFF",
  d: "M30.2 25.513v5.392c0 .292-.126.571-.35.777-.224.205-.527.32-.843.318H1.417C.745 32 .2 31.496.2 30.875v-5.362h30zM21.04 2c.64 0 1.16.52 1.16 1.16v7.68c0 .64-.52 1.16-1.16 1.16H9.36c-.64 0-1.16-.52-1.16-1.16V3.16C8.2 2.52 8.72 2 9.36 2h11.68zm-4.836 2H14.2v1.998h-2V8h1.996l.004 2h2.004V8H18.2V5.998h-2L16.204 4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003A79",
  d: "M18.393 16c.446 0 .807.398.807.889V32h-8V16.889c0-.491.361-.889.807-.889h6.386zM7.38 16a.82.82 0 0 1 .82.82v2.36a.82.82 0 0 1-.82.82H5.02a.82.82 0 0 1-.82-.82v-2.36a.82.82 0 0 1 .82-.82h2.36zm18 0a.82.82 0 0 1 .82.82v2.36a.82.82 0 0 1-.82.82h-2.36a.82.82 0 0 1-.82-.82v-2.36a.82.82 0 0 1 .82-.82h2.36z"
}));

var SvgUnidadeDeSaude = function SvgUnidadeDeSaude(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnidadeDeSaude, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unidade-de-saude.07f3752a.svg";
export { ForwardRef as ReactComponent };